<div class="cr-body template-creator">
  <div class="container">
    <div class="template_cr">

      <!-- HERO: big photo + name -->
      <header class="cr-hero">
        <img class="cr-photo" [src]="imageSrc" alt="profileImage" />
        <div class="cr-shade"></div>
        <!-- Dynamic template name badge -->
        <div class="cr-type-badge">{{ templateName }}</div>
        <div class="cr-sticker">Hey!<br />Collab<br />with me</div>
        <div class="cr-title">
          <h1><span>{{ firstName }}</span> {{ lastName }}</h1>
          <p>{{ jobTitle }}<span *ngIf="companyName"> / {{ companyName }}</span></p>
        </div>
      </header>

      <!-- Ticker -->
      <div class="cr-ticker"><span>Content</span><i></i><span>Collab</span><i></i><span>Community</span><i></i><span>Create</span></div>

      <!-- Collab CTA -->
      <section class="cr-cta">
        <a class="cr-collab" [href]="'mailto:' + email" [style.background-color]="buttonColor || null">
          <i class="fa-solid fa-handshake"></i>
          <span><b>Work with me</b><small>Brand deals &amp; collabs</small></span>
          <i class="cr-arrow fa-solid fa-arrow-right"></i>
        </a>
      </section>

      <div class="cr-about" *ngIf="content" [innerHTML]="content"></div>

      <!-- Social tiles -->
      <section class="cr-tiles" *ngIf="instagram || youtube || pinterest || twitter || facebook || linkedin">
        <div class="cr-h">Find me on</div>
        <div class="cr-grid">
        <a class="cr-tile cr-t-instagram" *ngIf="instagram" [href]="instagram" target="_blank"><i class="fa-brands fa-instagram"></i><span>Instagram</span></a>
        <a class="cr-tile cr-t-youtube" *ngIf="youtube" [href]="youtube" target="_blank"><i class="fa-brands fa-youtube"></i><span>YouTube</span></a>
        <a class="cr-tile cr-t-pinterest" *ngIf="pinterest" [href]="pinterest" target="_blank"><i class="fa-brands fa-pinterest-p"></i><span>Pinterest</span></a>
        <a class="cr-tile cr-t-twitter" *ngIf="twitter" [href]="twitter" target="_blank"><i class="fa-brands fa-twitter"></i><span>Twitter</span></a>
        <a class="cr-tile cr-t-facebook" *ngIf="facebook" [href]="facebook" target="_blank"><i class="fa-brands fa-facebook-f"></i><span>Facebook</span></a>
        <a class="cr-tile cr-t-linkedin" *ngIf="linkedin" [href]="linkedin" target="_blank"><i class="fa-brands fa-linkedin-in"></i><span>LinkedIn</span></a>
        </div>
      </section>

      <!-- Custom links -->
      <section class="cr-links" *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle">
        <div class="cr-h">Links</div>
        <ng-container *ngFor="let button of buttons">
          <a class="cr-link" *ngIf="button" [href]="button.LinkButtonLink" target="_blank">
            <span>{{ button.LinkButtonTitle }}</span>
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </a>
        </ng-container>
      </section>

      <!-- VIDEOS: YouTube + Umyotube (YouTube / Dailymotion / umyovideo) + Vimeo -->
      <section class="cr-videos">
        <div class="cr-sec-title" *ngIf="(youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) || (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) || (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)">
          <i class="fa-solid fa-circle-play"></i> Latest drops
        </div>

        <ng-container *ngFor="let v of youtubeArray">
          <div class="cr-video" *ngIf="v.youtubeLink | videoEmbed as src">
            <p class="cr-video-title"><i class="fa-brands fa-youtube"></i> {{ v.youtubeTitle }}</p>
            <div class="cr-embed">
              <iframe [src]="src" [title]="v.youtubeTitle || 'YouTube player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of umyotubeArray">
          <div class="cr-video" *ngIf="v.umyotubeLink | videoEmbed as src">
            <p class="cr-video-title"><i class="fa-solid fa-circle-play"></i> {{ v.umyotubeTitle }}</p>
            <div class="cr-embed">
              <iframe [src]="src" title="Umyotube player" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of vimeoArray">
          <div class="cr-video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
            <p class="cr-video-title"><i class="fa-brands fa-vimeo-v"></i> {{ v.vimeoVideoTitle }}</p>
            <div class="cr-embed">
              <iframe [src]="src" [title]="v.vimeoVideoTitle || 'Vimeo player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>
      </section>

      <section class="cr-gallery" *ngIf="productImages">
        <img *ngFor="let img of productImages; trackBy: trackByIndex" [src]="img" alt="productImage" />
      </section>

      <div class="cr-facts" *ngIf="gpa || school || grade || height || age || weight">
        <span *ngIf="gpa"><b>GPA</b> {{ gpa }}</span>
        <span *ngIf="school"><b>School</b> {{ school }}</span>
        <span *ngIf="grade"><b>Grade</b> {{ grade }}</span>
        <span *ngIf="height"><b>Height</b> {{ height }}</span>
        <span *ngIf="age"><b>Age</b> {{ age }}</span>
        <span *ngIf="weight"><b>Weight</b> {{ weight }}</span>
      </div>

      <section class="cr-contact">
        <a [href]="'tel:' + phone" class="cr-c-tel"><i class="fa-solid fa-phone"></i><span>Call</span></a>
        <a [href]="'sms:' + phone" *ngIf="phoneAllow" class="cr-c-sms"><i class="fa-solid fa-comments"></i><span>Text</span></a>
        <a [href]="'mailto:' + email" class="cr-c-mail"><i class="fa-solid fa-envelope"></i><span>Email</span></a>
        <a [href]="'https://www.google.com/maps?q=' + address" target="_blank" class="cr-c-map" *ngIf="address"><i class="fa-solid fa-location-dot"></i><span>Map</span></a>
      </section>

      <div class="cr-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share"></i><h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket"></i><h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download"></i><h3>Save My Card</h3>
        </button>
      </div>

      <footer class="cr-footer">
        <img class="cr-qr" *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
        <p class="cr-strip">Create <i></i> Share <i></i> Inspire</p>
        <p class="cr-powered">This card is powered by <span>UMYO Cards</span></p>
        <form action="" class="referal-form" *ngIf="inviteCode">
          <label for="referal">Referral ID: </label>
          <input type="text" name="referal" id="referal" [value]="referal" disabled placeholder="XXXXX" />
        </form>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>